import React from 'react';

function ArrowUp({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M12 19V5" />
      <path d="M19 12L12 5L5 12" />
    </svg>
  );
}

export default ArrowUp;
